// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CampaignTable-module__tableContainer___UItZI {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 16px 32px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    overflow: hidden;
    background: white;
    transform: perspective(1000px) translateZ(0);
    margin: 20px 0;
}

.CampaignTable-module__campaignTable___CLQaA {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    transition: transform 0.3s ease;
}

    .CampaignTable-module__campaignTable___CLQaA th {
        color: black;
        width: calc(100% / 12);
        box-sizing: border-box;
        background: #f5f5f5;
        position: relative;
        padding: 15px 10px;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 0.9em;
        border-bottom: 2px solid #e0e0e0;
    }

    .CampaignTable-module__campaignTable___CLQaA td {
        padding: 12px 10px;
        border-bottom: 1px solid #e0e0e0;
        transition: background-color 0.2s ease;
    }

.CampaignTable-module__campaignRow___VWyd3 {
    cursor: pointer;
    transition: all 0.2s ease;
}

    .CampaignTable-module__campaignRow___VWyd3:hover {
        background-color: #f8f8f8;
        transform: translateZ(2px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }

.CampaignTable-module__selectedCampaign___mrXJO {
    cursor: pointer;
    background-color: #f0f0f0;
    position: relative;
    transform: translateZ(4px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.05);
}

.CampaignTable-module__campaignTable___CLQaA tbody tr:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
}

.CampaignTable-module__campaignTable___CLQaA img[alt="Loading"] {
    animation: CampaignTable-module__pulse___1k9ux 1.5s infinite ease-in-out;
}

@keyframes CampaignTable-module__pulse___1k9ux {
    0% {
        opacity: 0.6;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0.6;
    }
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/CampaignTable/CampaignTable.module.css"],"names":[],"mappings":"AAAA;IACI,0EAA0E;IAC1E,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,+BAA+B;AACnC;;IAEI;QACI,YAAY;QACZ,sBAAsB;QACtB,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;QAChB,yBAAyB;QACzB,gBAAgB;QAChB,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;QAClB,gCAAgC;QAChC,sCAAsC;IAC1C;;AAEJ;IACI,eAAe;IACf,yBAAyB;AAC7B;;IAEI;QACI,yBAAyB;QACzB,0BAA0B;QAC1B,yCAAyC;IAC7C;;AAEJ;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,uEAAuE;AAC3E;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,wEAA0C;AAC9C;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".tableContainer {\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 16px 32px rgba(0, 0, 0, 0.05);\n    border-radius: 8px;\n    overflow: hidden;\n    background: white;\n    transform: perspective(1000px) translateZ(0);\n    margin: 20px 0;\n}\n\n.campaignTable {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    transition: transform 0.3s ease;\n}\n\n    .campaignTable th {\n        color: black;\n        width: calc(100% / 12);\n        box-sizing: border-box;\n        background: #f5f5f5;\n        position: relative;\n        padding: 15px 10px;\n        font-weight: 600;\n        text-transform: uppercase;\n        font-size: 0.9em;\n        border-bottom: 2px solid #e0e0e0;\n    }\n\n    .campaignTable td {\n        padding: 12px 10px;\n        border-bottom: 1px solid #e0e0e0;\n        transition: background-color 0.2s ease;\n    }\n\n.campaignRow {\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n    .campaignRow:hover {\n        background-color: #f8f8f8;\n        transform: translateZ(2px);\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    }\n\n.selectedCampaign {\n    cursor: pointer;\n    background-color: #f0f0f0;\n    position: relative;\n    transform: translateZ(4px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.05);\n}\n\n.campaignTable tbody tr:not(:last-child) {\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.campaignTable img[alt=\"Loading\"] {\n    animation: pulse 1.5s infinite ease-in-out;\n}\n\n@keyframes pulse {\n    0% {\n        opacity: 0.6;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0.6;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `CampaignTable-module__tableContainer___UItZI`,
	"campaignTable": `CampaignTable-module__campaignTable___CLQaA`,
	"campaignRow": `CampaignTable-module__campaignRow___VWyd3`,
	"selectedCampaign": `CampaignTable-module__selectedCampaign___mrXJO`,
	"pulse": `CampaignTable-module__pulse___1k9ux`
};
export default ___CSS_LOADER_EXPORT___;
